import styled from 'styled-components';

export const ManagerContainer = styled.div`
  padding: 10px 10px 10px 18px;
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
`;

export const ManagerContainerHeader = styled.span`
  font-size: 0.7rem;
  line-height: 2.6;
  color: ${({ theme }) => theme.baseBlue.a6};
  text-transform: uppercase;
`;

export const ManagerContainerContent = styled.span`
  font-size: 0.866rem;
`;

export const ManagerPlaceholder = styled.span`
  color: ${({ theme }) => theme.baseBlue.a6};
`;

export const UserTemplateError = styled.div`
  margin-top: 10px;
  color: ${({ theme }) => theme.red.a10};
  font-style: italic;
  font-weight: 300;
  font-size: 0.8rem;
  text-align: end;
`;
